/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransportMethodOptionDto
 */
export interface TransportMethodOptionDto {
    /**
     * 运输方式ID
     * @type {number}
     * @memberof TransportMethodOptionDto
     */
    id?: number;
    /**
     * 运输方式类型
     * @type {number}
     * @memberof TransportMethodOptionDto
     */
    type?: number;
    /**
     * 运输方式中文名称
     * @type {string}
     * @memberof TransportMethodOptionDto
     */
    nameCn?: string;
    /**
     * 运输方式韩文名称
     * @type {string}
     * @memberof TransportMethodOptionDto
     */
    nameKr?: string;
}

/**
 * Check if a given object implements the TransportMethodOptionDto interface.
 */
export function instanceOfTransportMethodOptionDto(value: object): value is TransportMethodOptionDto {
    return true;
}

export function TransportMethodOptionDtoFromJSON(json: any): TransportMethodOptionDto {
    return TransportMethodOptionDtoFromJSONTyped(json, false);
}

export function TransportMethodOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportMethodOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
    };
}

export function TransportMethodOptionDtoToJSON(json: any): TransportMethodOptionDto {
    return TransportMethodOptionDtoToJSONTyped(json, false);
}

export function TransportMethodOptionDtoToJSONTyped(value?: TransportMethodOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'nameCn': value['nameCn'],
        'nameKr': value['nameKr'],
    };
}

